import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  Fragment,
} from "react";
import { Typography, Stack, Box, Grid, Button, Divider } from "@mui/material";
import { useQuery } from "@apollo/client";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
import { BsPrinter } from "react-icons/bs";
//Srcs
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import {
  getKhmerMonth,
  getKhmerNumber,
  currencyFormat,
} from "../../Function/DynamicFn";
import { GET_YEARLY_STUDENT_REGISTER_PAID_SCHOOL_FEE } from "../../Schema/Report";
import {
  ConvertToEnglishWordsDollar,
  ConvertToKhmerWordsDollar,
} from "../Include/ReadCurrency";

function loop_elements(countValue) {
  let row = [];
  for (let i = 0; i < countValue?.length; i++) {
    row.push(i);
  }
  return row;
}

export default function StudStatisticSchoolFee({
  programmeListId,
  academicYearVal,
  tableRef,
}) {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [tableReport, setTableReport] = useState([]);

  // //Export to excel
  // const tableRef = useRef(null);
  // const { onDownload } = useDownloadExcel({
  //   currentTableRef: tableRef.current,
  //   filename: "Student-tuition-report",
  //   sheet: "Student-Tuition-Information",
  // });

  //  ================ Print PDF ===========================
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const componentRef = useRef(null);
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        onClick={handleOpen}
        className="btn-create"
        startIcon={
          // <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
          <BsPrinter alt="CreateIcon" className="icon-add" />
        }
      >
        Print
      </Button>
    );
  };

  // ====================== End Print PDF ===============================
  const { refetch } = useQuery(GET_YEARLY_STUDENT_REGISTER_PAID_SCHOOL_FEE, {
    variables: {
      academicYearId: academicYearVal?.id,
      programmeId: programmeListId,
      // academicYearId: "6658238ee00ea18408ce0a8f",
      // programmeId: ["61cc100036a74a5ec1bce476", "61cc105136a74a5ec1bce49b"],
      // programmeId: ["61cc100036a74a5ec1bce476", "61cc105136a74a5ec1bce49b"]
    },
    onCompleted: ({ getYearlyAmountPaid }) => {
      // console.log("getYearlyAmountPaid::", getYearlyAmountPaid);
      setTableData(getYearlyAmountPaid);
      setLoading(false);

      if (getYearlyAmountPaid?.dataByProgramme?.length > 0) {
        let rowOfReport = [];

        getYearlyAmountPaid?.dataByProgramme?.map(
          (programeElement, indexProgrme) =>
            programeElement?.dataByClassGroup?.map(
              (clasGroupElement, indexClassGroup) =>
                clasGroupElement?.dataByGrade?.map(
                  (gradeElement, indexGrade) => {
                    if (gradeElement?.dataByClass?.length > 0) {
                      //
                      gradeElement?.dataByClass?.map(
                        (classElement, indexClass) => {
                          const allRow = {
                            programmeName: programeElement?.programmeName,
                            classGroupName: clasGroupElement?.classGroupName,
                            gradeName: gradeElement?.gradeName,
                            className: classElement?.className,
                            roomNumber: classElement?.roomNumber,
                            studyShift: classElement?.studyShift,
                            numberOfStudentPaidByClass:
                              classElement?.numberOfStudentPaidByClass,
                            totalByMonth: classElement?.totalByMonth,
                          };

                          if (rowOfReport?.length === 0) {
                            rowOfReport?.push(allRow);
                          } else if (rowOfReport?.length > 0) {
                            let filterHaveGradeClass = rowOfReport?.filter(
                              (e) =>
                                e?.gradeName === allRow?.gradeName &&
                                e?.className === allRow?.className
                            );

                            if (filterHaveGradeClass?.length === 0) {
                              rowOfReport?.push(allRow);
                            }
                          }
                        }
                      );
                    } else {
                      const allRow = {
                        programmeName: programeElement?.programmeName,
                        classGroupName: clasGroupElement?.classGroupName,
                        gradeName: gradeElement?.gradeName,
                        className: "",
                        roomNumber: "",
                        studyShift: "",
                        totalByMonth: [],
                      };

                      if (rowOfReport?.length === 0) {
                        rowOfReport?.push(allRow);
                      } else if (rowOfReport?.length > 0) {
                        let filterHaveGradeClass = rowOfReport?.filter(
                          (e) =>
                            e?.gradeName === allRow?.gradeName &&
                            e?.className === allRow?.className
                        );

                        if (filterHaveGradeClass?.length === 0) {
                          rowOfReport?.push(allRow);
                        }
                      }
                    }
                  }
                )
            )
        );

        setTableReport([...rowOfReport]);
      } else {
        setTableReport([]);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [programmeListId, academicYearVal?.id]);

  // console.log("tableData==>", tableData)
  // console.log("tableReport==>", tableReport)

  // console.log("tableReport?.filter( (e) => e?.classGroupName === row?.classGroupName)",tableReport?.filter( (e) => e?.classGroupName === "បឋមសិក្សា"))

  const totalAmountStudentByGradeAndClass = (gradeName, className) => {
    let totalAmount = 0;

    // Filter the tableReport array based on gradeName and className
    const filteredData =
      tableReport?.filter(
        (e) => e?.gradeName === gradeName && e?.className === className
      ) || [];

    // Use reduce to calculate newTotal and totalAmount
    filteredData?.map((firstData, index) => {
      firstData?.totalByMonth?.map((month) => {
        totalAmount += month?.totalAmount;
      });
    });

    return { totalAmount };
  };

  const totalAmountStudentByGrades = (gradeName) => {
    let totalAmount = 0;

    // Filter the tableReport array based on gradeName and className
    const filteredData =
      tableReport?.filter((e) => e?.gradeName === gradeName) || [];

    // Use reduce to calculate newTotal and totalAmount
    filteredData?.map((firstData, index) => {
      firstData?.totalByMonth?.map((month) => {
        totalAmount += month?.totalAmount;
      });
    });

    return { totalAmount };
  };

  const totalStudentByGrades = (gradeName) => {
    let totalStudent = 0;

    // Filter the tableReport array based on gradeName and className
    const filteredData =
      tableReport?.filter((e) => e?.gradeName === gradeName) || [];

    // Use reduce to calculate newTotal and totalStudent
    // filteredData?.map((firstData, index) => {
    //   firstData?.totalByMonth?.map((month) => {
    //     totalStudent += month?.numberOfStudentPaid;
    //   })
    // })

    //Find total student paid by grade
    totalStudent = filteredData.reduce(
      (a, b) => a + b?.numberOfStudentPaidByClass,
      0
    );

    return { totalStudent };
  };

  const totalAmountStudentByClassGroup = (classGroupName) => {
    let totalAmount = 0;

    let newArray = tableReport?.filter(
      (e) => e?.classGroupName === classGroupName
    );

    newArray?.map((firstData, index) => {
      firstData?.totalByMonth?.map((month) => {
        totalAmount += month?.totalAmount;
      });
    });
    return { totalAmount };
  };

  const totalAmountStudentByPrograme = (programmeName) => {
    let totalAmount = 0;
    // console.log("programmeName:::", programmeName)
    let newArray = tableReport?.filter(
      (e) => e?.programmeName === programmeName
    );
    // console.log("newArray:::", newArray)

    newArray?.map((firstData, index) => {
      firstData?.totalByMonth?.map((month) => {
        totalAmount += month?.totalAmount;
      });
    });
    return { totalAmount };
  };

  const totalStudentByPrograme = (programmeName) => {
    let totalStudent = 0;
    // console.log("programmeName:::", programmeName)
    let newArray = tableReport?.filter(
      (e) => e?.programmeName === programmeName
    );
    // console.log("newArray:::", newArray)

    // newArray?.map((firstData, index) => {
    //   firstData?.totalByMonth?.map((month) => {
    //     totalStudent += month?.numberOfStudentPaid;
    //   })
    // })
    const findTotalStudent = newArray?.map((e) => {
      return e?.numberOfStudentPaidByClass ? e?.numberOfStudentPaidByClass : 0;
    });
    totalStudent = findTotalStudent?.reduce((a, b) => a + b, 0);
    return { totalStudent };
  };

  const totalStudents = () => {
    let totalStudent = 0;
    let newArray = tableReport;

    // newArray?.map((firstData, index) => {
    //   firstData?.totalByMonth?.map((month) => {
    //     totalStudent += month?.numberOfStudentPaid;
    //   })
    // })
    const findTotalStudent = newArray?.map((e) => {
      return e?.numberOfStudentPaidByClass ? e?.numberOfStudentPaidByClass : 0;
    });
    totalStudent = findTotalStudent?.reduce((a, b) => a + b, 0);

    return { totalStudent };
  };

  const totalStudentsByClassGroup = (classGroupName) => {
    let totalStudent = 0;
    let newArray = tableReport?.filter(
      (e) => e?.classGroupName === classGroupName
    );

    // newArray?.map((firstData, index) => {
    //   firstData?.totalByMonth?.map((month) => {
    //     totalStudent += month?.numberOfStudentPaid;
    //   })
    // })
    // // console.log(classGroupName, "classGroupName");
    // console.log(newArray, "newArray");
    const findTotalStudent = newArray?.map((e) => {
      return e?.numberOfStudentPaidByClass ? e?.numberOfStudentPaidByClass : 0;
    });
    totalStudent = findTotalStudent?.reduce((a, b) => a + b, 0);

    return { totalStudent };
  };

  const totalAmountStudents = (programmeName) => {
    let totalAmount = 0;
    let newArray = tableReport;

    newArray?.map((firstData, index) => {
      firstData?.totalByMonth?.map((month) => {
        totalAmount += month?.totalAmount;
      });
    });
    return { totalAmount };
  };

  const totalStudentMonthOfProgram = (programmeName) => {
    let newRow = [];
    let newArray = tableReport?.filter(
      (e) => e?.programmeName === programmeName
    );

    // console.log(newArray);
    //=============
    newArray?.map((firstData, index) => {
      if (index === 0) {
        firstData?.totalByMonth?.map((month, indexMonth) => {
          let allRow = {
            key: index + indexMonth + 1,
            monthName: month?.monthName,
            totalAmount: month?.totalAmount,
          };
          newRow.push(allRow);
        });
      }

      if (index > 0) {
        firstData?.totalByMonth?.map((month, indexMonth) => {
          //
          let filterNameMonth = newRow?.filter(
            (elem) => elem?.monthName === month?.monthName
          );

          if (filterNameMonth?.length > 0) {
            newRow.map((element, index) => {
              if (element?.key === index + indexMonth + 1) {
                element.totalAmount += month.totalAmount;
              }
            });
          }
        });
      }
    });

    return newRow;
  };

  const startYear = academicYearVal?.title?.slice(0, 4) || "";
  const endYear = academicYearVal?.title?.slice(5, 9) || "";
  const totalAmount = totalAmountStudents()?.totalAmount;
  return (
    <Box sx={{ marginTop: "20px" }}>
      <Box
        sx={{ bgcolor: "#fff", borderRadius: "10px" }}
        className="dibursement-print-container"
      >
        <Grid container>
          <Grid item xs={3}>
            <Stack direction="column">
              <img
                src={school}
                alt="school"
                className="logo-size"
                // style={{ width: "100px" }}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack direction="column">
              <Stack justifyContent="center" alignItems="center">
                <Typography className="disbursement-title-kh">
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography className="disbursement-title">
                  Kingdom Of Cambodia
                </Typography>
                <Typography className="disbursement-title-kh">
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography className="disbursement-title">
                  Nation Region King
                </Typography>
                <img src={symbol} alt="" width="110px" />
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
        {/* <Stack direction="row" width="100%" justifyContent="right" spacing={3}>
            <Typography className="number-text">លេខ ៖</Typography>
            <Typography className="number-text">026 / 24</Typography>
          </Stack> */}

        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          marginTop="15px"
          spacing={0.5}
        >
          <Typography className="disbursement-table-title">
            ស្ថិតិសិស្សបង់ថ្លៃការសិក្សាសម្រាប់ឆ្នាំសិក្សា{" "}
            {getKhmerNumber(startYear) + " - " + getKhmerNumber(endYear)}
          </Typography>
          <Typography className="disbursement-table-title-header">
            {/* កម្រិត​ Early Year Foundation Stage */}
          </Typography>
        </Stack>
        <Box sx={{ marginTop: "10px" }} justifyContent="center">
          <Box ref={tableRef}>
            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  Kingdom Of Cambodia
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  Nation Region King
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  ស្ថិតិសិស្សបង់ថ្លៃការសិក្សាសម្រាប់ឆ្នាំសិក្សា ២០២៤-២០២៥
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </table>
            <table className="table-cash">
              <thead className="thead-cash">
                <tr>
                  <td
                    className="title-table-stat"
                    style={{ width: "1%" }}
                    rowSpan={3}
                  >
                    ល.រ
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "7%" }}
                    rowSpan={3}
                  >
                    កម្មវិធីសិក្សា & ភូមិសិក្សា & កម្រិត
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "4%" }}
                    rowSpan={3}
                  >
                    ថ្នាក់
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "2.5%" }}
                    rowSpan={3}
                  >
                    វេន
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "2.5%" }}
                    rowSpan={3}
                  >
                    បន្ទប់
                  </td>
                  {/* <td className="title-table-stat" style={{ width: "3%" }} rowSpan={2}>
                    {getKhmerNumber(startYear) +
                      " - " +
                      getKhmerNumber(endYear)}
                  </td>
                  <td className="title-table-stat" style={{ width: "3%" }} rowSpan={2}>
                    ផែនការ
                  </td> */}
                  <td
                    className="title-table-stat"
                    style={{ width: "4%" }}
                    colSpan={tableData?.totalNum?.length + 2}
                  >
                    ២០២៤-២០២៥
                  </td>
                </tr>
                <tr>
                  <td className="title-table-stat" style={{ width: "4%" }}>
                    សរុបសិស្សបង់ប្រាក់
                  </td>
                  <td className="title-table-stat" style={{ width: "4%" }}>
                    សរុបទឹកប្រាក់
                  </td>
                  {tableData?.totalNum?.map((e, index) => {
                    return (
                      <td
                        className="title-table-stat"
                        key={index}
                        style={{ width: "3%" }}
                      >
                        {getKhmerMonth(e?.monthName?.toString())}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  {/* <td className="title-table-stat" style={{ width: "4%" }} >
                    0
                  </td>
                  <td className="title-table-stat" style={{ width: "4%" }} >
                    0
                  </td> */}
                  <td className="title-table-stat">
                    {totalStudents()?.totalStudent}
                  </td>
                  <td className="title-table-stat">
                    {currencyFormat(totalAmountStudents()?.totalAmount)}
                  </td>
                  {tableData?.totalNum?.map((d, index) => {
                    return (
                      <React.Fragment key={index}>
                        <td
                          className="title-table-stat"
                          style={{ width: "2%" }}
                        >
                          {currencyFormat(d?.totalAmount)}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              </thead>

              <tbody className="tbody-cash">
                {tableData?.dataByProgramme?.map((programe, indexPrograme) => (
                  <Fragment key={indexPrograme}>
                    <tr>
                      <td
                        className="title-table-stat"
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      ></td>
                      <td
                        className="title-table-stat"
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      >
                        {programe?.programmeName}
                      </td>
                      <td
                        className="title-table-stat"
                        colSpan={3}
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      ></td>
                      {/* <td
                        className="title-table-stat"
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      >
                        0
                      </td>
                      <td
                        className="title-table-stat"
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      >
                        0
                      </td> */}
                      <td
                        className="title-table-stat"
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      >
                        {
                          totalStudentByPrograme(programe?.programmeName)
                            ?.totalStudent
                        }
                      </td>
                      <td
                        className="title-table-stat"
                        style={{
                          backgroundColor: "#0f81c2",
                          color: "white",
                        }}
                      >
                        {currencyFormat(
                          totalAmountStudentByPrograme(programe?.programmeName)
                            ?.totalAmount
                        )}
                      </td>
                      {totalStudentMonthOfProgram(programe?.programmeName)?.map(
                        (monthElement, indexMonth) => {
                          return (
                            <React.Fragment key={indexMonth}>
                              <td className="title-table-stat">
                                {/* {monthElement?.totalAmount} */}
                              </td>
                            </React.Fragment>
                          );
                        }
                      )}
                    </tr>

                    {programe?.dataByClassGroup?.map(
                      (classGroup, indexClassGroup) => (
                        <React.Fragment key={indexClassGroup}>
                          <tr
                            key={indexClassGroup}
                            style={{ backgroundColor: "#dde7f0", color: "red" }}
                          >
                            <td className="title-table-stat" colSpan={5}>
                              {classGroup?.classGroupName}
                            </td>
                            {/* <td className="title-table-stat">
                              0
                            </td>
                            <td className="title-table-stat">
                              0
                            </td> */}
                            <td className="title-table-stat">
                              {
                                totalStudentsByClassGroup(
                                  classGroup?.classGroupName
                                )?.totalStudent
                              }
                            </td>
                            <td
                              className="title-table-stat"
                              style={{ color: "red", fontWeight: "bold" }}
                            >
                              {currencyFormat(
                                totalAmountStudentByClassGroup(
                                  classGroup?.classGroupName
                                )?.totalAmount
                              )}
                            </td>
                            {tableData?.totalNum?.map(
                              (monthElement, indexMonth) => (
                                <React.Fragment key={indexMonth}>
                                  <td className="title-table-stat"></td>
                                </React.Fragment>
                              )
                            )}
                          </tr>

                          {classGroup?.dataByGrade?.map((grade, indexGrade) => {
                            //=========== filter grade name ============
                            const rowGrade = tableReport?.filter(
                              (e) => e?.gradeName === grade?.gradeName
                            );

                            return loop_elements(rowGrade)?.map(
                              (elementClass, indexClassGroup) =>
                                indexClassGroup === 0 ? (
                                  <React.Fragment key={indexClassGroup}>
                                    <tr>
                                      <td className="title-table-stat">
                                        {indexClassGroup + 1}
                                      </td>
                                      <td
                                        className="title-table-stat"
                                        rowSpan={rowGrade?.length}
                                      >
                                        {rowGrade[elementClass]?.gradeName}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.className}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.studyShift}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.roomNumber}
                                      </td>
                                      {/* <td className="title-table-stat">
                                        0
                                      </td>
                                      <td className="title-table-stat">
                                        0
                                      </td> */}
                                      <td className="title-table-stat">
                                        {
                                          rowGrade[elementClass]
                                            ?.numberOfStudentPaidByClass
                                        }
                                      </td>
                                      <td className="title-table-stat">
                                        {currencyFormat(
                                          totalAmountStudentByGradeAndClass(
                                            rowGrade[elementClass]?.gradeName,
                                            rowGrade[elementClass]?.className
                                          )?.totalAmount
                                        )}
                                      </td>
                                      {rowGrade[
                                        elementClass
                                      ]?.totalByMonth?.map(
                                        (monthElement, indexMonth) => (
                                          <React.Fragment key={indexMonth}>
                                            <td className="title-table-stat">
                                              {currencyFormat(
                                                monthElement?.totalAmount
                                              )}
                                            </td>
                                          </React.Fragment>
                                        )
                                      )}
                                    </tr>
                                  </React.Fragment>
                                ) : loop_elements(rowGrade)?.length ===
                                  indexClassGroup + 1 ? (
                                  <React.Fragment key={indexClassGroup}>
                                    <tr key={indexClassGroup}>
                                      <td className="title-table-stat">
                                        {indexClassGroup + 1}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.className}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.studyShift}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.roomNumber}
                                      </td>
                                      {/* <td className="title-table-stat">
                                          0
                                        </td>
                                        <td className="title-table-stat">
                                          0
                                        </td> */}
                                      <td className="title-table-stat">
                                        {
                                          rowGrade[elementClass]
                                            ?.numberOfStudentPaidByClass
                                        }
                                      </td>
                                      <td className="title-table-stat">
                                        {currencyFormat(
                                          totalAmountStudentByGradeAndClass(
                                            rowGrade[elementClass]?.gradeName,
                                            rowGrade[elementClass]?.className
                                          )?.totalAmount
                                        )}
                                      </td>
                                      {rowGrade[
                                        elementClass
                                      ]?.totalByMonth?.map(
                                        (monthElement, indexMonth) => (
                                          <React.Fragment key={indexMonth}>
                                            <td className="title-table-stat">
                                              {currencyFormat(
                                                monthElement?.totalAmount
                                              )}
                                            </td>
                                          </React.Fragment>
                                        )
                                      )}
                                    </tr>

                                    <tr
                                      key={indexClassGroup}
                                      style={{ backgroundColor: "#ecece0" }}
                                    >
                                      <td
                                        className="title-table-stat"
                                        align="center"
                                        colSpan={5}
                                      >
                                        សរុប {rowGrade[elementClass]?.gradeName}
                                      </td>
                                      {/* <td className="title-table-stat" align="center">
                                          0
                                        </td>
                                        <td className="title-table-stat" align="center">
                                          0
                                        </td> */}
                                      <td
                                        className="title-table-stat"
                                        align="center"
                                        style={{
                                          color: "red",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {
                                          totalStudentByGrades(
                                            rowGrade[elementClass]?.gradeName
                                          )?.totalStudent
                                        }
                                        {/* {console.log((rowGrade[elementClass]?.gradeName))} */}
                                      </td>
                                      <td
                                        className="title-table-stat"
                                        align="center"
                                        style={{
                                          color: "red",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {currencyFormat(
                                          totalAmountStudentByGrades(
                                            rowGrade[elementClass]?.gradeName
                                          )?.totalAmount
                                        )}
                                      </td>
                                      {tableData?.totalNum?.map(
                                        (monthElement, indexMonth) => (
                                          <React.Fragment key={indexMonth}>
                                            <td className="title-table-stat">
                                              {/* {monthElement?.totalAmount} */}
                                            </td>
                                          </React.Fragment>
                                        )
                                      )}
                                    </tr>
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment key={indexClassGroup}>
                                    <tr key={indexClassGroup}>
                                      <td className="title-table-stat">
                                        {indexClassGroup + 1}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.className}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.studyShift}
                                      </td>
                                      <td className="title-table-stat">
                                        {rowGrade[elementClass]?.roomNumber}
                                      </td>
                                      {/* <td className="title-table-stat">
                                          0
                                        </td>
                                        <td className="title-table-stat">
                                          0
                                        </td> */}
                                      <td className="title-table-stat">
                                        {
                                          rowGrade[elementClass]
                                            ?.numberOfStudentPaidByClass
                                        }
                                      </td>
                                      <td className="title-table-stat">
                                        {currencyFormat(
                                          totalAmountStudentByGradeAndClass(
                                            rowGrade[elementClass]?.gradeName,
                                            rowGrade[elementClass]?.className
                                          )?.totalAmount
                                        )}
                                      </td>
                                      {rowGrade[
                                        elementClass
                                      ]?.totalByMonth?.map(
                                        (monthElement, indexMonth) => (
                                          <React.Fragment key={indexMonth}>
                                            <td className="title-table-stat">
                                              {currencyFormat(
                                                monthElement?.totalAmount
                                              )}
                                            </td>
                                          </React.Fragment>
                                        )
                                      )}
                                    </tr>
                                  </React.Fragment>
                                )
                            );
                          })}
                        </React.Fragment>
                      )
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>

            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  នាយិការង
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Deputy of School Principal
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Financial Affairs Director
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  អ្នករៀបចំ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Prepare by
                </td>
              </tr>
            </table>
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            <Grid container spacing={0.5}>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  ចំនួនទឹកប្រាក់ជាអក្សរ ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToKhmerWordsDollar(totalAmount)}
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  Amount in words ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToEnglishWordsDollar(totalAmount)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center">
                  <Typography className="disbursement-table-title">
                    នាយិការង
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Deputy of School Principal
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    វេត ស្រីម៉ៅ
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={1}>
                  <Typography className="disbursement-table-title">
                    ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Financial Affairs Director
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ខូវ ស៊ូខេង
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={2}>
                  <Typography className="disbursement-table-title">
                    អ្នករៀបចំ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Prepare by
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ស៊ុន ផាត់សន
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
